const updateFunc = (controlData) => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;

  const d = prevalence;
  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const tpr = tp / 100;
  const fnr = fn / 100;
  const atp = tpr * d;
  const afn = fnr * d;

  const jsonTruePositiveActual = { Status: "True positive" };
  const jsonFalseNegativeActual = { Status: "False negative" };
  const jsonRemaining = { Status: "." };
  const repeatedTruePositiveActual = Array(Math.round(atp)).fill(
    jsonTruePositiveActual
  );
  const repeatedFalseNegativeActual = Array(Math.round(afn)).fill(
    jsonFalseNegativeActual
  );
  const repeatedRemaining = Array(Math.round(1000 - atp - afn)).fill(
    jsonRemaining
  );
  let calculatedData = repeatedTruePositiveActual.concat(
    repeatedFalseNegativeActual
  );
  calculatedData = calculatedData.concat(repeatedRemaining);

  return calculatedData;
};

export default updateFunc;
